import { FormattedMessage } from 'react-intl'
import { CRUISE_PROMOTION_FOUR_PEOPLE } from 'lib/cruises/cruiseUtils'

interface Props {
  promotion?: string
}

export default function CruisePromotionPriceUnit({ promotion }: Props) {
  if (promotion !== CRUISE_PROMOTION_FOUR_PEOPLE) return null

  return <FormattedMessage
    id="9IGdKE-wZGHrxK9BmYo4"
    defaultMessage="for {passengerCount} people"
    description="Label following a cruise promotional total price for a fixed number of people"
    values={{ passengerCount: 4 }}
  />
}
